import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import MuiIcon from '@material-ui/core/Icon';

import IconExperiment from 'icons/IconExperiment';

const styles = (theme) => {
  const {
    spacing: { unit },
  } = theme;
  return {
    fiIcon: {
      width: 16,
      textAlign: 'center',
    },
    svgIcon: {
      fontSize: 12,
      marginLeft: unit / 2,
      marginTop: unit / 2,
    },
    muiIcon: {
      fontSize: 16,
      marginTop: unit / 4,
    },
  };
};

class Icon extends PureComponent {
  render() {
    const { classes, icon } = this.props;

    if (icon.startsWith('fi-')) {
      return <i className={classnames(icon, classes.fiIcon)} />;
    }
    if (icon === 'IconExperiment') {
      return <IconExperiment className={classes.svgIcon} />;
    }
    return <MuiIcon className={classes.muiIcon}>{icon}</MuiIcon>;
  }
}

Icon.propTypes = {
  classes: PropTypes.object.isRequired,
  icon: PropTypes.string.isRequired,
};

export default withStyles(styles)(Icon);
